// Uses the chrome.storage API for storing and retrieving data

const get = (keys) => {
  return new Promise((resolve, reject) => {
    chrome.storage.sync.get(keys, (entries) => {
      if (chrome.runtime.lastError) {
        reject({ error: chrome.runtime.lastError.message })
      } else {
        resolve(entries)
      }
    })
  })
}

const set = (items) => {
  return new Promise((resolve, reject) => {
    chrome.storage.sync.set(items, () => {
      if (chrome.runtime.lastError) {
        reject({ error: chrome.runtime.lastError.message })
      } else {
        resolve()
      }
    })
  })
}

const remove = (keys) => {
  return new Promise((resolve, reject) => {
    chrome.storage.sync.remove(keys, () => {
      if (chrome.runtime.lastError) {
        reject({ error: chrome.runtime.lastError.message })
      } else {
        resolve()
      }
    })
  })
}

// Used for debugging
const displayName = 'chromeStorageAdapter'

const chromeStorageAdapter = {
  get,
  set,
  remove,
  displayName,
}

export default chromeStorageAdapter
